// extracted by mini-css-extract-plugin
module.exports = {"pagination":"styles_pagination__1pVyf","pagination__Button":"styles_pagination__Button__81PmW","pagination__Button_Disabled":"styles_pagination__Button_Disabled__3JpaO"};